<template>
    <div class="row reports-global-information" v-if="data.length > 0">
        <div class="col">
            <div class="row">
                <div class="col">
                    <div class="row">
                        <div class="col-12 d-flex align-items-center mb-3">
                            <div class="subtitle" v-if="title">{{ $t(title) }}</div>
                            <button v-if="allowExportData"
                                :title="titleExportData"
                                class="btn btn-link min-w-auto text-decoration-none z-depth-0 py-0 m-0"
                                type="button"
                                @click.prevent="onExport">
                                <i class="fas fa-download"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row info-row">
                <div class="col info-col" v-for="(item, index) in data" :key="index">
                    <div class="info-content">
                        <p class="card-text text-nowrap info-title" :style="{color: item.color}">
                            {{ item.name }}
                        </p>
                        <p class="card-text info-qty">
                            <number :from="0" :to="item.period" :duration="3" :delay="0" easing="Power1.easeOut" />
                        </p>
                        <p class="card-text d-inline-block info-total">
                            <span class="pr-2">{{ txtTotal }}</span>
                            <number :from="0" :to="item.total" :duration="3" :delay="0" easing="Power1.easeOut" />
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {HasLoadingState, HasReport} from './mixins/index';
    import GlobalMixin from '@/app/shared/mixins/global';

    export default {
        name: 'reportGlobalInformationStatus',
        mixins: [
            HasLoadingState,
            HasReport,
            GlobalMixin
        ],
        props: {
            txtTotal: {
                type: String,
                default: 'No total'
            },
        },
        data() {
            return {

            }
        },
        methods: {

        }
    }
</script>

<style lang="scss" scoped>
    @import "@styles/_mixins.scss";
    @import '../../sass/theme';
    //@import "@styles/_theme.scss";
    .reports-global-information {
        .btn {
            font-size: 1rem;
        }

        .info-row {
            margin-right: -.6rem;
            margin-left: -.6rem;
            .info-col {
                padding-right: .6rem;
                padding-left: .6rem;
            }
        }

        .info-content {
            border-radius: $report-card-border-radius;
            border: $report-card-border;
            background-color: $report-card-bg-color;
            box-shadow: $report-card-shadow;
            padding: 1rem;
            text-align: $report-card-text-align;
            margin-bottom: 1.2rem;
            @include md {
                padding: $report-card-md-padding;
            }

            .card-body {

            }

            .card-text {
                margin-bottom: 0;
                color: $report-card-text-color;
                line-height: 1.63;
                font-size: .875rem;
                white-space: nowrap;


                &.info-title {
                    font-family: $report-card-header-font;
                }

                &.info-qty  {
                    font-family: $report-card-body-font;
                    font-size: 32px;
                    line-height: 1.25;
                }

                &.info-total  {
                    color: $report-card-total-color;
                    font-family: $report-card-footer-font;
                }
            }
        }
    }
</style>